import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ListContext } from '../context';
import ErrorMessage from '../ErrorMessage';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListItemGroup(props) {
  const {
    children = []
  } = props;
  const {
    isNoSearchResult
  } = useContext(ListContext);
  if (isNoSearchResult) {
    return /*#__PURE__*/React.createElement(ErrorMessage, null);
  }
  return /*#__PURE__*/React.createElement("ul", {
    id: "list-group",
    className: moduleStyles['sib-list__item-group']
  }, React.Children.map(children, (child, index) => {
    return /*#__PURE__*/React.cloneElement(child, {
      key: index,
      index
    });
  }));
}
ListItemGroup.propTypes = {
  children: PropTypes.node.isRequired
};
export default ListItemGroup;